// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footer":"footer-1JQJ8L1s","foot_link":"foot_link-2eTYDLLh","list":"list-Qb_Zl5Jv","link":"link-3VRzLO6d","copyright":"copyright-3ShvA_op"};